import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_453: DocMigration = {
  maxSchemaVersion: "0.0.453",
  description: "Fixes corrupted tags on view entities",
  apply(json: any) {
    // nested iterate over all the json looking for any object with a tags property that is a boolean
    const iterate = (obj: any) => {
      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null && typeof obj[key].tags === "boolean") {
          obj[key].tags = {};
        }
        if (typeof obj[key] === "object" && obj[key] !== null) {
          iterate(obj[key]);
        }
      }
    };
    iterate(json);

    return json;
  },
};

export default migration_0_0_453;
